/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Ref_H2Inputs */

const en_minifier_ref_h2 = /** @type {(inputs: Minifier_Ref_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Size`)
};

const ko_minifier_ref_h2 = /** @type {(inputs: Minifier_Ref_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`크기`)
};

const ja_minifier_ref_h2 = /** @type {(inputs: Minifier_Ref_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイズ`)
};

/**
* | output |
* | --- |
* | "Size" |
*
* @param {Minifier_Ref_H2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_ref_h2 = /** @type {((inputs?: Minifier_Ref_H2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Ref_H2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_ref_h2(inputs)
	if (locale === "ko") return ko_minifier_ref_h2(inputs)
	return ja_minifier_ref_h2(inputs)
});